import React from "react";
import GroupNavbar from "~/components/group/GroupNavbar";
import { IGroupNavbarProps } from "~/components/group/IGroupProps";

export default function GroupMobileNavbar({ group, tab }: IGroupNavbarProps) {
  return (
    <div
      css={{
        marginTop: 24,
      }}
    >
      <GroupNavbar group={group} tab={tab} />
    </div>
  );
}
